import { XMLParser, XMLBuilder, XMLValidator } from 'fast-xml-parser'
/*
 * Shared XML handling for transcripts
 * Used by transcriptProvider, Recording/index and TranscriptEditor
 */

// ensure nested elements are always parsed as arrays, even if there's only one
const isArray = (name, jpath, isLeafNode, isAttribute) =>
    !isAttribute && jpath.includes('.')

const options = {
    ignoreAttributes: false,
    attributesGroupName: '$',
    attributeNamePrefix: '',
    textNodeName: '_',
    ignoreDeclaration: true,
    parseTagValue: false, // don't parse tag values as numbers or booleans
    isArray,
}

const XML_DECLARATION = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'

export const parseXml = (text, { processAttributeValues = true } = {}) => {
    const validation = XMLValidator.validate(text)
    if (validation !== true) {
        throw new Error(`Invalid XML: ${validation.err.msg}`)
    }
    return new XMLParser({
        ...options,
        parseAttributeValue: processAttributeValues,
    }).parse(text)
}

export const buildXml = (object) => {
    const xml = new XMLBuilder({
        ...options,
        format: true,
        indentBy: '  ',
        suppressEmptyNode: true,
    }).build(object)
    return `${XML_DECLARATION}\n${xml.trimEnd()}`
}

export default parseXml
